import React, { Component } from 'react'

import { openModalWithContainer } from './../reducers/modals'
import Resource from '../Resource'

import '../styles/VideosContainer.css'

function toMMSS(seconds) {
  return `${Math.floor(seconds / 60)}:${seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60}`
}

export default class VideosContainer extends Component {
  render() {
    return (
      <Resource collection path={['sections']} placeholder={[]}>
        {(sections, sectionMutations) => (
          <Resource collection path={['videos']} placeholder={[]}>
            {(videos, { dispatch, ...videoMutations }) => (
              <div id="VideosContainer">
                <h3 className="tab-header">
                  Videos
                  {/* <div style={{ float: 'right' }}>
                    <div
                      className="btn btn-sm btn-primary"
                      onClick={() =>
                        dispatch(
                          openModalWithContainer('SectionContainer', {
                            section: null,
                            onSave: sectionMutations.onCreateItem,
                          })
                        )
                      }
                    >
                      Add Section
                    </div>
                  </div> */}
                </h3>
                {sections.map((section) => (
                  <div className="section" key={section.id}>
                    <h4>
                      {section.title}
                      <div style={{ float: 'right' }}>
                        <div
                          style={{ marginRight: 10 }}
                          className="btn btn-sm btn-outline-primary"
                          onClick={() =>
                            dispatch(
                              openModalWithContainer('SectionContainer', {
                                section: section,
                                onSave: sectionMutations.onUpdateItem,
                                onDelete: sectionMutations.onDeleteItem,
                              })
                            )
                          }
                        >
                          Edit
                        </div>
                        <div
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            dispatch(
                              openModalWithContainer('VideoContainer', {
                                video: null,
                                sectionId: section.id,
                                onSave: videoMutations.onCreateItem,
                              })
                            )
                          }
                        >
                          Add Video
                        </div>
                      </div>
                    </h4>
                    <div className="videos">
                      {videos
                        .filter((v) => v.sectionId === section.id)
                        .map((video) => (
                          <div
                            key={video.id}
                            className="video"
                            onClick={() =>
                              dispatch(
                                openModalWithContainer('VideoContainer', {
                                  video,
                                  sectionId: section.id,
                                  onSave: videoMutations.onUpdateItem,
                                  onDelete: videoMutations.onDeleteItem,
                                })
                              )
                            }
                          >
                            <img src={video.posterImageURL} className="poster" alt="poster" />
                            <div className="title">{video.title}</div>
                            <div className="duration">{toMMSS(video.duration)}</div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Resource>
        )}
      </Resource>
    )
  }
}
